import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { WidgetComponent } from 'app/widget/widgets/widget-component';
import { Subscription } from 'rxjs';
import { DashboardDataService } from '@widgets/services/dashboard-data.service';

@Component({
  selector: 'lms-surveys-widget',
  templateUrl: './surveys-widget.component.html',
  styleUrls: ['./surveys-widget.component.scss']
})
export class SurveysWidgetComponent implements WidgetComponent, OnInit, OnDestroy {
  @Input() data: any;

  public ratiosSubscription: Subscription;

  public ratios: any = {};

  constructor(public dashboardService: DashboardDataService) {}

  ngOnInit() {
    this.ratiosSubscription = this.dashboardService.getRatios({ groupId: this.data.group._id }).subscribe((ratios) => {
      this.ratios.ratioApplication = Math.ceil(ratios.ratioApplication);
      this.ratios.ratioRecommendation = Math.ceil(ratios.ratioRecommendation);
      this.ratios.ratioNPS = Math.ceil(ratios.ratioNPS);
    });
  }

  ngOnDestroy(): void {
    this.ratiosSubscription.unsubscribe();
  }
}
